import React, { useEffect } from 'react';
import axios from 'axios';
import { router } from 'router';
import { toast } from 'react-toastify';
import { saveCurrentPathForLoginRedirect } from 'services/loginRedirect';
import { useSelector } from 'react-redux';
import { selectUserLoggedIn } from 'modules/login/slice/loginSlice';

const apiHandler = (App) => {
  const Interceptor = (props) => {
    const isUserLoggedIn = useSelector(selectUserLoggedIn);

    useEffect(() => {
      axios.interceptors.response.use(
        (response) => {
          return response;
          //   if (response?.data) {
          //     return { data: response?.data, status: response.status };
          //   } else {
          //     return response;
          //   }
        },
        (error) => {
          switch (error?.response?.status) {
            case 500:
              // toast.show({
              //   position: 'bottom',
              //   type: 'error',
              //   text1: 'Internal Server Error ! Please Try after sometimes',
              //   visibilityTime: 1500,
              // });
              break;
            case 400:
              // toast.show({
              //   position: 'bottom',
              //   type: 'error',
              //   text1: 'Something Went Wrong',
              //   visibilityTime: 1500,
              // });
              break;
            case 429:
              toast.warning({
                position: 'bottom',
                type: 'error',
                text1: 'Too many requests. Please try again later.',
                visibilityTime: 1500,
              });
              break;
            case 401:
              saveCurrentPathForLoginRedirect(isUserLoggedIn);
              router.navigate('/login');
              break;
            case 404:
              // toast.show({
              //   position: 'bottom',
              //   type: 'error',
              //   text1: 'Something Went Wrong',
              //   visibilityTime: 1500,
              // });
              break;
            default:
              break;
          }

          // Do something with response error
          // toast.show({
          //   position: 'bottom',
          //   type: 'error',
          //   text1: error.message,
          //   visibilityTime: 1500
          // })

          return Promise.reject(error);
        }
      );
    }, [isUserLoggedIn]);

    return <App {...props} />;
  };
  return Interceptor;
};

export default apiHandler;
